module.exports = __webpack_public_path__ + "media/images/athletes/2874-38ec637984c84d3d01ee9686f6f2d9df.png";